<template>
  <div>
  
		<div class="container-fluid">
      <div class="page-header">
        <div class="row">
          <div class="col-lg-8">
            <div class="page-header-left">
              <!--<h3>{{(breadcrumbsItems.title != '')?breadcrumbsItems.title:breadcrumbsItems.main}}</h3>-->
              <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link :to="{ path: '/dashboard/default' }"><feather type="home"></feather></router-link></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level1 != ''"><router-link v-if="breadcrumbsItems.level1_to != ''" :to="breadcrumbsItems.level1_to">{{breadcrumbsItems.level1}}</router-link><span v-if="breadcrumbsItems.level1 != '' && breadcrumbsItems.level1_to == ''">{{breadcrumbsItems.level1}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level2 != ''"><router-link v-if="breadcrumbsItems.level2_to != ''" :to="breadcrumbsItems.level2_to">{{breadcrumbsItems.level2}}</router-link><span v-if="breadcrumbsItems.level2 != '' && breadcrumbsItems.level2_to == ''">{{breadcrumbsItems.level2}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level3 != ''"><router-link v-if="breadcrumbsItems.level3_to != ''" :to="breadcrumbsItems.level3_to">{{breadcrumbsItems.level3}}</router-link><span v-if="breadcrumbsItems.level3 != '' && breadcrumbsItems.level3_to == ''">{{breadcrumbsItems.level3}}</span></li>
                <li class="breadcrumb-item" v-if="breadcrumbsItems.level4 != ''"><router-link v-if="breadcrumbsItems.level4_to != ''" :to="breadcrumbsItems.level4_to">{{breadcrumbsItems.level4}}</router-link><span v-if="breadcrumbsItems.level4 != '' && breadcrumbsItems.level4_to == ''">{{breadcrumbsItems.level4}}</span></li>
              </ol>
            </div>
          </div>
          <div class="col-lg-4">
            <div class="bookmark pull-right">
              <ul>
                <li>
                  <a class="text-dark ml-2" href="#" @click.prevent="actualizar"><feather v-b-tooltip.hover title="Actualizar" type="refresh-cw"></feather></a>
                  <a class="text-dark ml-2" href="#" @click.prevent="crear" v-if="permissions.management || permissions.supervision"><feather v-b-tooltip.hover title="Nuevo" type="plus"></feather></a>
                  <a class="text-dark ml-2" href="#" @click.prevent="editar" v-if="show_action_button_edit"><feather v-b-tooltip.hover title="Editar" type="edit-2"></feather></a>
                </li>
                <li class="ml-2">
                  <a href="javascript:void(0)" @click='openSearchBox()'><feather  class="bookmark-search star-yellow" type="search"></feather></a>
                  <form class="form-inline search-form" @submit.prevent="actualizar">
                    <div class="form-group form-control-search" :class="searchBox ? 'open' : 'close'">
                      <input type="text" placeholder="Buscar.." v-model="filtro.buscar" :disabled="loading">
                    </div>
                  </form>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
   
		<div class="container-fluid">
			<div class="row">
				<div class="col-md-12">
					<div class="card">
						<div class="card-header p-4">

              <form @submit.prevent="actualizar">

                <div class="form-row" :disabled="loading">

                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 mb-0">
                    <label class="form_label_bold" for="filtro_empresa">{{ (environment_name == 'zunige')?'Empresa':'Grupo de trabajo'}}</label>
                    <treeselect class="module_dynamic_form_combo" v-model="filtro.v2_empresa_id" :clearable="false" :disable-branch-nodes="true" :disabled="loading" required 
                    :options="empresas" :searchable="false" :auto-load-root-options="false" :cache-options="false" @select="cambioEmpresa" :open-on-focus="true"/>
                  </div>

                  <div class="col-xl-2 col-lg-2 col-md-3 col-sm-4 mb-0">
                    <label class="form_label_bold" for="filtro_empresa">Estado</label>                    
                    <treeselect class="module_dynamic_form_combo" v-model="filtro.enable" :clearable="false" :disable-branch-nodes="true" placeholder="Estado" 
                    :options="[{ id: 'true', label: 'Activos' },{ id: 'false', label: 'Eliminados' }]" :searchable="false" :auto-load-root-options="false" :cache-options="false" @select="actualizar" 
                    :open-on-focus="true"/>
                  </div>

                </div>

              </form>

						</div>
						<div class="card-body p-4">
							<div class="table-responsive datatable-vue m-0 vue-smart">
								<v-data-table :headers="headers" :items="items" class="module_data_table" :disabled="loading" 
                  :total-items="totalItems" :pagination.sync="pagination" item-key="id" v-model="selected"
                  rows-per-page-text="Registros por página" :rows-per-page-items='[10]' :selected="selected" select-all>
                    <template slot="items" slot-scope="props">
                        <td>
                            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
                        </td>
                        <td v-for="header in headers" @click="clickRow(props.item)">
                          <span v-if="header.value.includes('vigencia')">{{ formatDate(props.item[header.value]) }}</span>
                          <span v-if="header.value == 'estado_name'" :class="'class_for_Report_state_' + props.item[header.value]">{{ props.item[header.value] }}</span>
                          <b-link href="#" @click="view(props.item)" v-if="header.value == 'version'">{{ props.item[header.value] }}</b-link>
                          <span v-if="!header.value.includes('vigencia') && header.value != 'estado_name' && header.value != 'version'">{{ props.item[header.value] }}</span>
                        </td>
                    </template>
                </v-data-table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ReportNew ref="ReportNew" v-on:closeModal="closeModal" :key="ReportNewRandomKey"/>
  </div>  

</template>

<script>

import Vue from 'vue';
import moment from 'moment'
const Swal = require('sweetalert2')
import Treeselect from '../utils/vue-treeselect/src/components/Treeselect'

import ReportNew from './ReportNew' 

export default {
  components: {
    Treeselect,
    ReportNew
  },
  computed: {
    show_action_button: {
      get: function () {
        if (this.selected.length == 0) {
          return false;
        } else if (this.selected.length == 1) {
          return true;
        } else if (this.selected.length > 1) {
          return true;
        } else {
          return false;
        }
      }
    },
    show_action_button_edit () { //ok
      if (this.selected.length == 1 && this.permissions.management) {
        return true;
      } else {
        return false;
      }
    },
    show_action_button_view () { //ok
      if (this.selected.length == 1) {
        return true;
      } else {
        return false;
      }
    },
  },
  data () {
    return {
      model: 'report',
      loading: false,
      environment_name: localStorage.environment_name, //esto lo agrego para saber si cambio el nombre de Empresa a Grupo de Trabajo
      headers: [],
      items: [],
      totalItems: 0,
      pagination: {rowsPerPage: 10},
      filtro: {
        enable: "true"
      },
      selected: [],
      empresas: [],
      permissions: {},
      breadcrumbsItems: {
        title: 'Gestor de Reportes',
        level1: 'Reportes',
        level1_to: '',
        level2: 'Gestor de Reportes',
        level2_to: '',
        level3: '',
        level3_to: '',
        level4: '',
        level4_to: ''
      },
      searchBox: false,  // agrego esto
      ReportNewRandomKey: 1,  // agrego esto
    }

  },
  watch: {
    pagination: {
      handler () {
        if (this.items.length > 0) {

          var data = {}
          data.limit = this.pagination.rowsPerPage
          data.page = this.pagination.page
          data.ascending = !this.pagination.descending
          data.orderBy = this.pagination.sortBy
          data.query = this.filtro
          
          this.getReportes_rows(this.filtro.v2_empresa_id,data)
            .then(data => {
              this.items = data.items
              this.totalItems = data.total
            })
        }
      },
      deep: true
    }
  },
  mounted() {

    this.$store.dispatch("main_filters/setModuleName", this.model);

    this.getEmpresas()
      .then(data => {
        this.empresas = data.items
        
        if(localStorage.empresa_id > 0){
          this.filtro.v2_empresa_id = localStorage.empresa_id
          this.cambioEmpresa(localStorage.empresa_id)
        } else {
          if(data.items.length > 0){
            this.filtro.v2_empresa_id = data.items[0].id
            this.cambioEmpresa(data.items[0].id)
          }
        }
      })
  },
  created () {
    try {
      if (!localStorage.signedIn) {
        this.$router.push('/')
      } else {

        localStorage.page_return = ""

        //valido permisos
        var accesos = JSON.parse(localStorage.accesos)
        accesos.forEach(acceso => {
          if(acceso.model == "case"){
            this.permissions[acceso.permission] = true
          }
        });
      }  
    } catch (error) {
      this.showError(error)
    }
  },
  methods: {
    cambioEmpresa (empresa){

      var v2_empresa_id = undefined

      if ( empresa.id ) {
        v2_empresa_id = empresa.id
      } else {
        v2_empresa_id = empresa        
      }

      localStorage.empresa_id = v2_empresa_id

      this.getReportes_Headers(v2_empresa_id)
      .then(data => {
        this.headers = data.items
      })

      this.actualizar()
    },
    actualizar () {

      var data = {}
      data.limit = this.pagination.rowsPerPage
      data.page = this.pagination.page
      data.ascending = !this.pagination.descending
      data.orderBy = this.pagination.sortBy
      data.query = this.filtro

      this.getReportes_rows(this.filtro.v2_empresa_id,data)
      .then(data => {
        this.items = data.items
        this.totalItems = data.total
      })
    },
    clickRow (row) {
      var insert = true;
      for (let index = 0; index < this.selected.length; index++) {
        const element = this.selected[index];
        if (element.id == row.id) {
          insert = false;
          this.selected.splice(index, 1); 
          break;
        }
      }
      if (insert) {
        this.selected.push(row)
      }
    },
    view (item) {
      this.$router.push("/report/read/"+ ((this.selected[0] != undefined)?this.selected[0].id:item.id))
    },
    editar (item){
      this.$router.push("/report/config/"+ this.selected[0].id)
    },
    crear (item){
      this.$refs.ReportNew.init(this.filtro.v2_empresa_id);
      this.$bvModal.show("ReportNew")
    },
    openSearchBox() {  //agrego esto
      this.searchBox = !this.searchBox
      if(!this.searchBox)
        this.closeSearchBox()
    },
    closeSearchBox() {  //agrego esto
      document.getElementById("canvas-bookmark").classList.remove("offcanvas-bookmark");
    },
    closeModal() {  //agrego esto
      this.actualizar()
      this.ReportNewRandomKey +=1
    },

  }
}
</script>
